// @flow
import { connect } from 'react-redux';

import { fetchAllContactForm7Forms } from 'actions/contactForm7Actions';
import { fetchJobDetail as fetchJobDetailAction } from 'actions/jobActions';
import JobDetail, { type StateProps, type DispatchProps } from 'components/job/jobDetail/JobDetail';
import type { DispatchType, StateType } from 'types/Actions';

export default connect(
  (state: StateType): StateProps => {
    let sidebar_content;
    if (state.pageDetailState.sidebar_content.length > 0) {
      sidebar_content = state.pageDetailState.sidebar_content;
    } else if (state.pageListState.sidebar_content.length > 0) {
      sidebar_content = state.pageListState.sidebar_content;
    } else {
      sidebar_content = state.pageNodeState.pageNode.sidebar_content;
    }

    const structureName = state.settingsState.ligue;

    return {
      title: 'Devenir bénévole',
      description: 'Retrouvez les offres du comité et des différents clubs et rejoignez la grande famille du rugby.',
      details: state.jobDetailState.details,
      meta_title: `${structureName} rugby : détail des missions bénévoles`,
      meta_description: `Bénévolat : détail des offres et inscription pour le comité ${structureName} et les clubs`,
      status: state.jobDetailState.status,
      contactFormList: state.contactForm7State.contactFormList,
      sidebar_content,
      structureName
    };
  },
  (dispatch: DispatchType): DispatchProps => ({
    fetchContactFormList: () => dispatch(fetchAllContactForm7Forms()),
    fetchJobDetail: (slug: string) => dispatch(fetchJobDetailAction(slug))
  })
)(JobDetail);
